import styled from "styled-components";

const Select = styled.select`
  padding: 10px 15px;
  border-radius: 12px;
  border: 1px solid #ccc;
`;

export default Select;